/* ═══════════════════════════════════════════════════════════════
   REUNITED — Global chrome (menu morph, footer accordion)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Menu: logo morphs to sun, full-screen overlay ── */
  var trigger = document.getElementById('ru-menu-trigger');
  var menu = document.getElementById('ru-menu');

  function setMenu(open) {
    document.body.classList.toggle('ru-menu-open', open);
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
    if (menu) menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  if (trigger && menu) {
    trigger.addEventListener('click', function () {
      setMenu(!document.body.classList.contains('ru-menu-open'));
    });
    // Close when clicking the empty overlay backdrop
    menu.addEventListener('click', function (e) { if (e.target === menu) setMenu(false); });
    // Close on link click
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('ru-menu-open')) setMenu(false);
    });
  }

  /* ── Header solidify on scroll for non-homepage (window scroll) ── */
  var header = document.getElementById('ru-header');
  if (header && header.classList.contains('is-transparent')) {
    // Only homepage starts transparent; the scroll controller drives it there.
    // For any other transparent context, fall back to window scroll.
    var isHomeScroll = !!document.getElementById('reunited-scroll');
    if (!isHomeScroll) {
      var onScroll = function () {
        if (window.scrollY > 200) header.classList.remove('is-transparent');
        else header.classList.add('is-transparent');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ── Footer accordion (mobile) ── */
  document.querySelectorAll('.ru-acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ru-acc-item');
      if (!item) return;
      var open = item.classList.contains('is-open');
      document.querySelectorAll('.ru-acc-item').forEach(function (i) {
        i.classList.remove('is-open');
        var s = i.querySelector('.sign'); if (s) s.textContent = '+';
      });
      if (!open) {
        item.classList.add('is-open');
        var sign = item.querySelector('.sign'); if (sign) sign.textContent = '\u2212';
      }
    });
  });

  /* ── Search affordance (links to Shopify search page) ── */
  document.querySelectorAll('[data-ru-search]').forEach(function (b) {
    b.addEventListener('click', function () { window.location.href = '/search'; });
  });

  /* ── Back control (product pages) → return to the grid, else the shop ── */
  document.querySelectorAll('[data-ru-back]').forEach(function (b) {
    b.addEventListener('click', function () {
      var shop = b.getAttribute('data-shop') || '/collections/all';
      var ref = document.referrer || '';
      if (ref.indexOf(window.location.origin) === 0 && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = shop;
      }
    });
  });
})();
